import {
  Component,
  OnInit,
  AfterViewInit,
  ChangeDetectorRef
} from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { RequestModel } from 'src/app/shopping-cart/request-model.model';
import { ShoppingCartService } from 'src/app/shopping-cart/shopping-cart.service';
import { stateValidator } from 'src/app/validators/state-validator';
import { TrimFormControl } from '../trim-control';
import { TouchFormControl } from 'src/app/validation-banner/touch-form-control.modal';
import { ProviderTypeService } from 'src/app/prov-service/provider-type.service';
import { RequestTypeService } from 'src/app/req-type/request-type.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { EventService } from 'src/app/main/event-service/event.service';
import { State } from '../state.model';

@Component({
  selector: 'app-new',
  templateUrl: './new.component.html',
  styleUrls: ['../../app.component.scss']
})
export class NewComponent implements OnInit, AfterViewInit {
  private _NEW = true;
  private _myForm: FormGroup;
  private _doc: File;
  private _optDocs: File[] = [];
  private _index: number = -1;
  private _request: RequestModel;
  private _duplicated: RequestModel = null;
  private _emitRequest: RequestModel;
  private _reqToggle = 'new';
  private _showBanner = false;

  constructor(
    private cartService: ShoppingCartService,
    private ref: ChangeDetectorRef,
    private providerService: ProviderTypeService,
    private requestTypeService: RequestTypeService,
    private modalService: BsModalService,
    private eventService: EventService
  ) {}
  
  ngAfterViewInit(): void {
    this.reqToggle = this.index != null ? 'update' : 'new';
    this.ref.detectChanges();
  }

  ngOnInit() {
    this.myForm = new FormGroup({
      name: new TrimFormControl('', [
        Validators.required,
        Validators.pattern(/^[A-Za-z0-9\&\-\,\.\/\:\#\'\(\) ]+$/)
      ]),
      middleInitial: new TrimFormControl('', [
        Validators.pattern(/^[A-Za-z]+$/)
      ]),
      lastName: new TrimFormControl('', [
        Validators.required,
        Validators.pattern(/^[A-Za-z0-9\&\-\,\.\/\:\#\'\(\) ]+$/)
      ]),
      idType: new TouchFormControl('NPI', []),
      NPI: new TrimFormControl('', [Validators.required]),
      taxID: new TrimFormControl('', []),
      country: new TrimFormControl('US', [Validators.required]),
      requestDetails: new TrimFormControl('', [Validators.required]),
      providerType: new TouchFormControl(''),
      requestType: new TouchFormControl(''),
      caqhId: new TrimFormControl('', [Validators.pattern(/^[a-zA-Z\d-]+$/)]),
      optDoc: new TouchFormControl(''),
      doc: new TouchFormControl('') // this form does not require a doc,
      // this form control enables the forms to be loaded from the same component.
    });

    this.index = this.eventService.request;
    this.request = this.cartService.getSingleRequest(this.index);
    this.duplicated = this.eventService.requestModel;

    if (this.index !== null && this.myForm.controls['country'].value === 'US') {
      this.myForm.addControl(
        'state',
        new TrimFormControl('', [Validators.required, stateValidator([])])
      );
      this.optDocs = this.request.optDocs;
    }
    else if (this.duplicated !== null && this.myForm.controls['country'].value === 'US') {
      this.myForm.addControl(
        'state',
        new TrimFormControl('', [Validators.required, stateValidator([])])
      );
    }
    else {
      this.myForm.addControl(
        'state',
        new TrimFormControl('', [Validators.required, stateValidator([])])
      );
    }
  }

  public updateOptFile(docs: any): void {
    if (docs) {
      this.optDocs = docs;
    }
  }

  public updateRequest(emitRequest: any) {
    this._emitRequest = emitRequest;
  }

  public closeParent(close?: any): void {
    this.modalService._hideModal();
    this.modalService._hideBackdrop();
    
    let valid = true;

    if (close !== undefined) {
      valid = close;
    }

    this.eventService.confirmEvent.emit(new State(false, valid, this.reqToggle));
  }

  public submit(event: any): void {
    if (this.submittable()) {
      const request = this.myForm.value;

      const type = 'P02';
      request.providerType = this.providerService.provider[type];

      const reqType = 'R02';
      request.requestType = this.requestTypeService.reqType[reqType];

      request.optDocs = this.optDocs;

      if (this._emitRequest) {
        request.state = this._emitRequest.state;
        request.gateway = this._emitRequest.gateway
          ? this._emitRequest.gateway
          : false;
      }
      else {
        request.state = null;
        request.gateway = false;
      }

      this.closeParent();
      this._showBanner = false;

      this.request
        ? this.cartService.editRequest(this.index, request)
        : this.cartService.addToCart(request);
    }
    else if (this._myForm.invalid) {
      this._showBanner = true;
    }
  }

  public get duplicated(): RequestModel {
    return this._duplicated;
  }

  public set duplicated(duplicated: RequestModel) {
    this._duplicated = duplicated;
  }

  public set request(request: RequestModel) {
    this._request = request;
  }

  public get request(): RequestModel {
    return this._request;
  }

  public get myForm(): FormGroup {
    return this._myForm;
  }

  public set myForm(myForm: FormGroup) {
    this._myForm = myForm;
  }

  public set index(index: number) {
    this._index = index;
  }

  public get index(): number {
    return this._index;
  }

  public get doc(): File {
    return this._doc;
  }

  public set doc(doc: File) {
    this._doc = doc;
  }

  public get NEW(): boolean {
    return this._NEW;
  }

  public get emitRequest(): RequestModel {
    return this._emitRequest;
  }

  public set emitRequest(request: RequestModel) {
    this._emitRequest = request;
  }

  public get reqToggle() {
    return this._reqToggle;
  }

  public set reqToggle(reqToggle: string) {
    this._reqToggle = reqToggle;
  }

  public get optDocs(): File[] {
    return this._optDocs;
  }

  public set optDocs(value: File[]) {
    this._optDocs = value;
  }

  public get showBanner(): boolean {
    return this._showBanner && this._myForm.touched && !this._myForm.valid;
  }

  public submittable(): boolean {
    return this.myForm.touched && this.myForm.valid;
  }
}
